export const menu = function (el) {
    let clickTime = new Date().getTime();
    const menuEnabler = el.querySelector(".enable-menu");
    const menuDisabler = el.querySelector(".side-nav");
    if (window.innerWidth >= 768) {
        menuEnabler.addEventListener("mouseenter", menuOn);
        menuDisabler.addEventListener("mouseleave", menuOff);
    } else {
        menuEnabler.addEventListener("click", menuToggle);
    }

    function menuToggle() {
        if (document.body.classList.contains("menu-enabled")) {
            document.body.classList.remove("menu-enabled");
        } else {
            document.body.classList.add("menu-enabled");
        }
    }

    function menuOn() {
        if (!document.body.classList.contains("menu-enabled")) {
            document.body.classList.add("menu-enabled");
        }
    }

    function menuOff() {
        if (document.body.classList.contains("menu-enabled")) {
            document.body.classList.remove("menu-enabled");
        }
    }
};
